module.exports = new __parcel__URL__("ClickUp.fc84f5a1.svg").toString();